const translation = {
  title: 'Geri Alım Testi',
  desc: 'Verilen sorgu metnine göre Bilginin isabet etkisini test edin.',
  dateTimeFormat: 'GG/AA/YYYY ss:dd ÖÖ/ÖS',
  recents: 'Sonuçlar',
  table: {
    header: {
      source: 'Kaynak',
      text: 'Metin',
      time: 'Zaman',
    },
  },
  input: {
    title: 'Kaynak metin',
    placeholder: 'Bir metin girin, kısa bir bildirim cümlesi önerilir.',
    countWarning: 'En fazla 200 karakter.',
    indexWarning: 'Yüksek kaliteli Bilgi sadece.',
    testing: 'Test Ediliyor',
  },
  hit: {
    title: 'GERİ ALINAN PARAGRAFLAR',
    emptyTip: 'Geri Alım Testi sonuçları burada gösterilecektir',
  },
  noRecentTip: 'Burada son sorgu sonuçları yok',
  viewChart: 'VEKTÖR GRAFİĞİNİ GÖRÜNTÜLE',
  viewDetail: 'ayrıntılara bakın',
  settingTitle: 'Alma Ayarı',
  open: 'Açık',
  chunkDetail: 'Yığın Detayı',
  keyword: 'Anahtar kelime -ler',
  hitChunks: '{{num}} alt parçalarına basın',
  records: 'Kayıt',
}

export default translation
